import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Clock, Pencil, Trash2, Video } from 'lucide-react';
import { ASS_MAP } from './constants';
import { TagChips } from './shared';

export const ObservationTimeline = ({
  observations, filtered, obsFilter, setObsFilter, tagsById, canEdit, canDelete, onEdit, onDelete,
}) => (
  <Card data-testid="observation-timeline">
    <CardHeader className="pb-2">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <CardTitle className="text-base">Observations ({observations.length})</CardTitle>
        <div className="flex gap-1 flex-wrap" data-testid="obs-filters">
          {['all', 'positive', 'needs_improvement', 'neutral'].map(f => (
            <button key={f} onClick={() => setObsFilter(f)}
              className={`text-xs px-2 py-1 rounded border ${obsFilter === f
                ? 'bg-gray-800 text-white border-gray-800' : 'bg-white text-gray-600 border-gray-200'}`}
              data-testid={`obs-filter-${f}`}>
              {f === 'all' ? 'All' : ASS_MAP[f].label}
            </button>
          ))}
        </div>
      </div>
    </CardHeader>
    <CardContent className="space-y-2 max-h-[70vh] overflow-y-auto">
      {filtered.length === 0 && (
        <p className="text-sm text-gray-400 py-8 text-center" data-testid="obs-empty">No observations yet.</p>
      )}
      {filtered.map(o => {
        const am = ASS_MAP[o.assessment] || ASS_MAP.neutral;
        return (
          <div key={o.id} className="border rounded-lg p-3" data-testid={`obs-item-${o.id}`}>
            <div className="flex items-center justify-between gap-2">
              <div className="flex items-center gap-2 text-sm font-medium">
                <Clock className="w-3.5 h-3.5 text-gray-400" />
                {o.timestamp_display || '—'}{o.period ? ` · ${o.period}` : ''}
              </div>
              <div className="flex items-center gap-1">
                <Badge className={`${am.cls} gap-1 text-xs`}><span className={`w-1.5 h-1.5 rounded-full ${am.dot}`} />{am.label}</Badge>
                {canEdit && (
                  <button onClick={() => onEdit({ ...o, development_tag_ids: o.development_tag_ids || [] })}
                          className="text-gray-400 hover:text-emerald-600" data-testid={`obs-edit-${o.id}`}>
                    <Pencil className="w-3.5 h-3.5" />
                  </button>
                )}
                {canDelete && (
                  <button onClick={() => onDelete(o)} className="text-gray-400 hover:text-red-500" data-testid={`obs-delete-${o.id}`}>
                    <Trash2 className="w-3.5 h-3.5" />
                  </button>
                )}
              </div>
            </div>
            <p className="text-xs text-gray-500 mt-1">{o.category}</p>
            <div className="mt-1"><TagChips ids={o.development_tag_ids || []} tagsById={tagsById} /></div>
            {o.observation && <p className="text-sm text-gray-700 mt-2">{o.observation}</p>}
            {(o.evidence || []).length > 0 && (
              <div className="mt-2 flex items-center gap-1 text-xs text-sky-700" data-testid={`obs-evidence-${o.id}`}>
                <Video className="w-3.5 h-3.5" /> {o.evidence.length} evidence · {o.evidence.map(e => e.timestamp_display || e.source).join(', ')}
              </div>
            )}
          </div>
        );
      })}
    </CardContent>
  </Card>
);

export default ObservationTimeline;
